import { render, staticRenderFns } from "./CountByApplyDocResearcherRegionComponent.vue?vue&type=template&id=25a3bfd5&scoped=true&"
import script from "./CountByApplyDocResearcherRegionComponent.vue?vue&type=script&lang=js&"
export * from "./CountByApplyDocResearcherRegionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a3bfd5",
  null
  
)

export default component.exports